import SplitColorSection from './SplitColorSection';
import { H4 } from 'foundations-components/transitional/components/H4';
import { View } from 'foundations-components/components/View';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import FormattedMessage from 'I18n/components/FormattedMessage';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { Text } from 'foundations-components/components/Text';
import { CertificationIcon } from 'foundations-assets/icons/components/CertificationIcon';
import { GaugeIcon } from 'foundations-assets/icons/components/GaugeIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SplitSectionContent = ({
  heading,
  description,
  ctaTo,
  ctaMessageKey,
  icon,
  use = 'light'
}) => {
  return /*#__PURE__*/_jsxs(View, {
    maxInlineSize: "400px",
    textAlign: "center",
    children: [/*#__PURE__*/_jsx(IconHolder, {
      icon: icon,
      padding: "0",
      size: "900"
    }), /*#__PURE__*/_jsx(H4, {
      children: heading
    }), /*#__PURE__*/_jsx(Text, {
      as: "p",
      color: use === 'light' ? 'text-core-on-fill-default' : 'text-core-default',
      marginBlockEnd: "400",
      children: description
    }), /*#__PURE__*/_jsx(RouterButton, {
      to: ctaTo,
      use: "secondary-ghost",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: ctaMessageKey
      })
    })]
  });
};
const CoursesAndCertificationsSplitSection = () => {
  const leftColor = 'fill-accent-green-subtle';
  const rightColor = 'fill-accent-yellow-subtle';
  const use = 'dark';
  return /*#__PURE__*/_jsx(SplitColorSection, {
    "data-test-id": "courses-and-certifications-split-section",
    leftColor: leftColor,
    leftContent: /*#__PURE__*/_jsx(SplitSectionContent, {
      ctaMessageKey: "academyPublic.splitSection.leftSideCta",
      ctaTo: "/courses",
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.splitSection.leftSideDescription"
      }),
      heading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.splitSection.leftSideTitle"
      }),
      icon: GaugeIcon,
      use: use
    }),
    rightColor: rightColor,
    rightContent: /*#__PURE__*/_jsx(SplitSectionContent, {
      ctaMessageKey: "academyPublic.splitSection.rightSideCta",
      ctaTo: "/certification-overview",
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.splitSection.rightSideDescription"
      }),
      heading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.splitSection.rightSideTitle"
      }),
      icon: CertificationIcon,
      use: use
    }),
    use: use
  });
};
export default CoursesAndCertificationsSplitSection;